import { useTranslation } from 'react-i18next'
import { Settings2 } from 'lucide-react'
import { useAuthStore } from '@/stores/auth-store'
import { openStageManager } from '@/stores/stage-manager-store'

/** Chỉ chủ tổ chức / quản trị viên được đặt giai đoạn (backend: PUT /cdp/lifecycle/stages) — người khác không thấy lối vào. */
export function useCanManageStages(): boolean {
  const role = useAuthStore((s) => s.user?.role)
  return role === 'owner' || role === 'admin'
}

/** Đóng ô chọn (Radix Select / Popover) đang mở chứa nút này trước khi hiện hộp thoại. */
function dismissOpenLayer() {
  document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }))
}

/** Cuối ô chọn giai đoạn: mở hộp thoại quản lý giai đoạn NGAY TẠI màn đang làm việc (không chuyển sang Cài đặt). */
export function ManageStagesLink() {
  const { t } = useTranslation('sharedMisc')
  const can = useCanManageStages()
  if (!can) return null
  return (
    <div className="mt-1 border-t px-2 pt-1.5 pb-0.5">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          dismissOpenLayer()
          openStageManager()
        }}
        className="flex w-full items-center gap-1.5 rounded px-1 py-1 text-left text-xs text-primary hover:bg-muted"
      >
        <Settings2 className="h-3.5 w-3.5" /> {t('manageLinks.managePipeline')}
      </button>
    </div>
  )
}
